/**
 * UI State Reducer
 * Manages UI-related state (modals, dropdowns, views, etc.)
 */

export const uiStateActions = {
    SET_MODAL: 'SET_MODAL',
    SET_DROPDOWN: 'SET_DROPDOWN',
    SET_VIEW: 'SET_VIEW',
    SET_FILTER: 'SET_FILTER',
    SET_SELECTED_EVENTS: 'SET_SELECTED_EVENTS',
    SET_EXPANDED_INDEX: 'SET_EXPANDED_INDEX',
    SET_SELECTED_EVENT_FOR_EDIT: 'SET_SELECTED_EVENT_FOR_EDIT',
    RESET_MODALS: 'RESET_MODALS',
    SET_SELECTION_MODE: 'SET_SELECTION_MODE',
    SET_SELECTED_EVENTS_FOR_IMPORT: 'SET_SELECTED_EVENTS_FOR_IMPORT',
    SET_SELECT_ALL_EVENTS: 'SET_SELECT_ALL_EVENTS',
    SET_IMPORT_DATE_RANGE_MODAL: 'SET_IMPORT_DATE_RANGE_MODAL',
    SET_IMPORT_LOADING: 'SET_IMPORT_LOADING',
};

const initialState = {
    // Modal states
    modalIsOpen: false,
    createEventModalOpen: false,
    createHolidayModalOpen: false,
    isGoogleTokenInvalidModalOpen: false,
    isMicrosoftTokenInvalidModalOpen: false,
    isImportDateRangeModalOpen: false,
    
    // Dropdown states
    isOpen: false, // Create dropdown
    isUserDropdownOpen: false,
    isLeaveUserDropdownOpen: false,
    
    // View and selection
    view: 'month',
    filter: '',
    filt: '',
    selectedEvents: [],
    expandedEventIndex: null,
    selectedEventForEdit: null,
    
    // Import to time tracker
    isSelectionMode: false,
    selectedEventsForImport: [],
    selectAllEvents: false,
    importDateRange: { startDate: null, endDate: null },
    isImportLoading: false,
};

export const uiStateReducer = (state, action) => {
    switch (action.type) {
        case uiStateActions.SET_MODAL:
            return {
                ...state,
                [action.modalName]: action.isOpen,
            };
        
        case uiStateActions.SET_DROPDOWN:
            return {
                ...state,
                [action.dropdownName]: action.isOpen,
            };
        
        case uiStateActions.SET_VIEW:
            return {
                ...state,
                view: action.view,
            };
        
        case uiStateActions.SET_FILTER:
            return {
                ...state,
                filter: action.filter,
                filt: action.filter, // Keep filt in sync
            };
        
        case uiStateActions.SET_SELECTED_EVENTS:
            // Handle function updates (like React setState)
            const newEvents = typeof action.events === 'function' 
                ? action.events(state.selectedEvents)
                : action.events;
            // Ensure it's always an array
            const normalizedEvents = Array.isArray(newEvents) ? newEvents : [];
            return {
                ...state,
                selectedEvents: normalizedEvents,
            };
        
        case uiStateActions.SET_EXPANDED_INDEX:
            return {
                ...state,
                expandedEventIndex: action.index,
            };
        
        case uiStateActions.SET_SELECTED_EVENT_FOR_EDIT:
            return {
                ...state,
                selectedEventForEdit: action.event,
            };
        
        case uiStateActions.RESET_MODALS:
            return {
                ...state,
                modalIsOpen: false,
                createEventModalOpen: false,
                createHolidayModalOpen: false,
            };
        
        case uiStateActions.SET_SELECTION_MODE:
            return {
                ...state,
                isSelectionMode: action.isSelectionMode,
                selectedEventsForImport: action.isSelectionMode ? state.selectedEventsForImport : [],
                selectAllEvents: false,
            };
        
        case uiStateActions.SET_SELECTED_EVENTS_FOR_IMPORT:
            return {
                ...state,
                selectedEventsForImport: action.events,
            };
        
        case uiStateActions.SET_SELECT_ALL_EVENTS:
            return {
                ...state,
                selectAllEvents: action.selectAll,
            };
        
        case uiStateActions.SET_IMPORT_DATE_RANGE_MODAL:
            return {
                ...state,
                isImportDateRangeModalOpen: action.isOpen,
                importDateRange: action.dateRange || state.importDateRange,
            };
        
        case uiStateActions.SET_IMPORT_LOADING:
            return {
                ...state,
                isImportLoading: action.isLoading,
            };
        
        default:
            return state;
    }
};

